import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { environment } from 'src/environments/environment';

import { HelperNavControllerService } from '../helpers/helper-nav-controller.service';
import { ROUTE_DIRECTION } from '../types/route.type';
import { AppName } from '../types/environment.type';
import { getEnvironmentRedirectRoute } from '../helpers/helper-route.util';

export const appEnvironmentGuard = (...allowedApps: AppName[]): CanActivateFn => {
  return () => {
    const helperNavControllerService = inject(HelperNavControllerService);

    if (allowedApps.includes(environment.app)) {
      return true;
    }

    const redirectRoute = getEnvironmentRedirectRoute();
    helperNavControllerService.navigate(redirectRoute, ROUTE_DIRECTION.Root);
    return false;
  };
};
